"use strict";

var Match, React, classnames;

React = require("react");

classnames = require("classnames");

Match = React.createClass({
  displayName: "Match",

  propTypes: {
    item: React.PropTypes.oneOfType([React.PropTypes.object.isRequired, React.PropTypes.string]).isRequired,
    active: React.PropTypes.bool.isRequired,
    onSelect: React.PropTypes.func
  },
  onSelect: function onSelect() {
    return this.props.onSelect(this.props.item);
  },
  className: function className() {
    return classnames({
      active: this.props.active
    });
  },
  renderText: function renderText() {
    if (this.props.item.displayName != null) {
      return this.props.item.displayName;
    } else {
      return this.props.item;
    }
  },
  render: function render() {
    return React.createElement(
      "li",
      {
        onMouseDown: this.onSelect,
        className: this.className()
      },
      this.renderText()
    );
  }
});

module.exports = Match;


/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/TypeAhead/Match.js
 ** module id = 573
 ** module chunks = 0
 **/